export const MAX_IMAGE_BYTES = 20 * 1024 * 1024;
export const MAX_PDF_BYTES = 25 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;

export function newMessageId() {
  return `msg-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function validateFileSize(file) {
  const { type, size } = file;
  if (type.startsWith('image/') && size > MAX_IMAGE_BYTES) {
    throw new Error(`Image "${file.name}" exceeds 20 MB limit`);
  }
  if (type === 'application/pdf' && size > MAX_PDF_BYTES) {
    throw new Error(`PDF "${file.name}" exceeds 25 MB limit`);
  }
  if (type.startsWith('video/') && size > MAX_VIDEO_BYTES) {
    throw new Error(`Video "${file.name}" exceeds 50 MB limit`);
  }
  if (!type.startsWith('image/') && type !== 'application/pdf' && !type.startsWith('video/')) {
    throw new Error(`Unsupported file type: ${type || file.name}`);
  }
}

export async function filesToAttachments(files) {
  const newAttachments = [];
  for (const file of files) {
    validateFileSize(file);
    const data = await readFileAsDataUrl(file);
    newAttachments.push({
      id: newMessageId(),
      name: file.name,
      mime: file.type,
      data,
      preview: file.type.startsWith('image/') ? data : null,
    });
  }
  return newAttachments;
}
